import IconLaneBottom from './IconLaneBottom';

export default IconLaneBottom;